// extracted by mini-css-extract-plugin
export var afterLandingWrapper = "landing-layout-module--after-landing-wrapper--SOwZV";
export var landingWrapper = "landing-layout-module--landing-wrapper--ENDSr";